export const STEP_NUMBER = {
  STEP_1: 1, // Year and submodel select
  STEP_2: 2, // Questionnaire - DEPRECATED
  STEP_2_5: 2.5, // Style select from list
  STEP_3: 3, // Customizes
  STEP_4: 4, // Build Summary
  STEP_5: 5, // Get Quotes lead form
};

export const STEP_FILTERS = [
  { step: STEP_NUMBER.STEP_5, filters: ['modelyearId', 'submodel', 'styleId', 'priceBreakdown', 'getQuotes'] },
  { step: STEP_NUMBER.STEP_4, filters: ['modelyearId', 'submodel', 'styleId', 'priceBreakdown'] },
  { step: STEP_NUMBER.STEP_3, filters: ['modelyearId', 'submodel', 'styleId'] },
  { step: STEP_NUMBER.STEP_2_5, filters: ['modelyearId', 'submodel'] },
];

export const OPTION_TYPE = {
  COLOR: 'color',
  OPTION: 'option',
};

export const CONDITION_TYPE = {
  AND: 'AND',
  OR: 'OR',
  XOR: 'XOR',
};

export const SUBMODEL_IMAGE_SIZE = {
  PREVIEW: {
    HEIGHT: 200,
    WIDTH: 300,
  },
  SUMMARY: {
    HEIGHT: 400,
    WIDTH: 600,
  },
};

export const OVERVIEW_FEATURES_MAP = [
  {
    name: 'Engine Type',
    path: 'features.standard.Engine',
    fieldName: 'Base engine type',
  },
  {
    name: 'Transmission',
    path: 'features.standard["Drive Train"]',
    fieldName: 'Transmission',
  },
  {
    name: 'Drive Type',
    path: 'features.standard["Drive Train"]',
    fieldName: 'Drive type',
  },
  {
    name: 'Cylinders',
    path: 'features.standard.Engine',
    fieldName: 'Cylinders',
  },
  {
    name: 'Combined MPG',
    path: 'features.standard.Fuel',
    fieldName: 'Combined MPG',
    fallbackFieldName: 'EPA combined MPG',
  },
  {
    name: 'Total Seating',
    path: 'totalSeating',
  },
];

export const OPTIONS_RENDER_MAP = [
  {
    id: 'colors-section',
    type: OPTION_TYPE.COLOR,
    title: 'Colors',
    trackingIdSuffix: 'color',
    path: 'colors',
  },
  {
    id: 'packages-section',
    title: 'Packages',
    trackingIdSuffix: 'package',
    path: 'packages',
  },
  {
    id: 'mechanical-section',
    title: 'Mechanical options',
    trackingIdSuffix: 'mechanical_option',
    path: 'mechanicals',
  },
  {
    id: 'interior-section',
    title: 'Interior options',
    trackingIdSuffix: 'interior_option',
    path: 'interiors',
  },
  {
    id: 'exterior-section',
    title: 'Exterior options',
    trackingIdSuffix: 'exterior_option',
    path: 'exteriors',
  },
  {
    id: 'safety-section',
    title: 'Safety features',
    trackingIdSuffix: 'safety_feature',
    path: 'safetyFeatures',
  },
  {
    id: 'additional-fees-section',
    title: 'Additional fees',
    trackingIdSuffix: 'additional_fee',
    path: 'additionalFees',
  },
];

export const COLOR_CATEGORY_NAME = {
  EXTERIOR: 'Exterior',
  INTERIOR: 'Interior',
  ROOF: 'Roof',
  INTERIOR_TRIM: 'Interior Trim',
};

export const COLOR_SECTION_RENDER_MAP = [
  { path: 'EXTERIOR', title: COLOR_CATEGORY_NAME.EXTERIOR },
  { path: 'INTERIOR', title: COLOR_CATEGORY_NAME.INTERIOR, squared: true },
  { path: 'ROOF', title: COLOR_CATEGORY_NAME.ROOF, squared: true },
  { path: 'INTERIOR_TRIM', title: COLOR_CATEGORY_NAME.INTERIOR_TRIM, squared: true },
];

export const COLOR_SUMMARY_DISPLAY_MAP = {
  EXTERIOR: 'Ext. Color',
  INTERIOR: 'Int. Color',
  ROOF: 'Roof Color',
  INTERIOR_TRIM: 'Int. Trim Color',
};

export const EXCLUDED_SUMMARY_CATEGORIES = ['additionalFees'];

export const LEAD_FORM_OPTIONS_COMMENTS_MAP = [
  { category: 'EXTERIOR', title: `${COLOR_CATEGORY_NAME.EXTERIOR} color` },
  { category: 'INTERIOR', title: `${COLOR_CATEGORY_NAME.INTERIOR} color` },
  { category: 'ROOF', title: `${COLOR_CATEGORY_NAME.ROOF} color` },
  { category: 'INTERIOR_TRIM', title: `${COLOR_CATEGORY_NAME.INTERIOR_TRIM} color` },
  { category: 'packages', title: 'Packages' },
  { category: 'mechanicals', title: 'Mechanical options' },
  { category: 'interiors', title: 'Interior options' },
  { category: 'exteriors', title: 'Exterior options' },
  { category: 'safetyFeatures', title: 'Safety options' },
];

export const VEHICLE_SUMMARY_SECTION = {
  MODEL_YEAR: 'Model year',
  BODY_TYPE: 'Body type',
  TRIM: 'Trim',
  COLORS: 'Colors',
  OPTIONS: 'Options',
};

export const VEHICLE_SUMMARY_ALLOWED_SECTIONS = {
  [STEP_NUMBER.STEP_1]: [],
  [STEP_NUMBER.STEP_2_5]: [VEHICLE_SUMMARY_SECTION.MODEL_YEAR, VEHICLE_SUMMARY_SECTION.BODY_TYPE],
  [STEP_NUMBER.STEP_3]: [
    VEHICLE_SUMMARY_SECTION.MODEL_YEAR,
    VEHICLE_SUMMARY_SECTION.BODY_TYPE,
    VEHICLE_SUMMARY_SECTION.TRIM,
  ],
  [STEP_NUMBER.STEP_4]: [
    VEHICLE_SUMMARY_SECTION.MODEL_YEAR,
    VEHICLE_SUMMARY_SECTION.BODY_TYPE,
    VEHICLE_SUMMARY_SECTION.TRIM,
    VEHICLE_SUMMARY_SECTION.COLORS,
    VEHICLE_SUMMARY_SECTION.OPTIONS,
  ],
  [STEP_NUMBER.STEP_5]: [
    VEHICLE_SUMMARY_SECTION.MODEL_YEAR,
    VEHICLE_SUMMARY_SECTION.BODY_TYPE,
    VEHICLE_SUMMARY_SECTION.TRIM,
    VEHICLE_SUMMARY_SECTION.COLORS,
    VEHICLE_SUMMARY_SECTION.OPTIONS,
  ],
};

export const BARS_PER_DEAL = {
  DEFAULT: 5,
  WITH_COUNTS: 3,
};
